import { Route, Routes } from "react-router-dom";

import { AdditionalInfo } from "./Views/AdditionalInfo/AdditionalInfo";
import { AdminUserContextProvider } from "core/state/AdminUserContext";
import { AppLayout } from "./UIPalette/AppLayout";
import { Auth } from "./Views/Auth/Auth";
import { ClientAdminManagement } from "./Views/ClientAdminManagement/ClientAdminManagement";
import { ClientManagement } from "./Views/ClientManagement/ClientManagement";
import { Dashboard } from "./Views/Dashboard/Dashboard";
import DualBranding from "./Views/DualBranding/DualBranding";
import { WWAdminManagement } from "./Views/WWAdminManagement/WWAdminManagement";
import { HubSites } from "./Views/HubSites/HubSites";
import { ImportClients } from "./Views/ImportClients/ImportClients";
import { Communications } from "./Views/Communications/Communications";
import RouteAuthorisation from "core/auth/routeAuthorisation";
import { TargetGroups } from "./Views/TargetGroups/TargetGroups";
import { WisdomUserManagement } from "./Views/WisdomUserManagement/WisdomUserManagement";
import { changeLanguage } from "i18next";
import { protect } from "core/auth/ProtectedRoute";
import { useGetAdminLocale } from "core/hooks/useGetAdminLocale";
import { PendingNotifications } from "./Views/PendingNotifications/PendingNotifications";
import { NotifyModalContextProvider } from "shared/core/state/NotifyModalContext/NotifyModalContext";
import { ModalProvider } from "shared/core/state/ModalContext/ModalContext";

export const App = () => {
  const locale = useGetAdminLocale(window.location.hostname);
  changeLanguage(locale);
  return (
    <ModalProvider>
      <AdminUserContextProvider>
        <Routes>
          <Route
            element={protect(
              <NotifyModalContextProvider>
                <AppLayout />
              </NotifyModalContextProvider>
            )}
          >
            <Route index element={protect(<Dashboard />, RouteAuthorisation.dashboard)} />
            <Route path="dashboard" element={protect(<Dashboard />, RouteAuthorisation.dashboard)} />
            <Route path="usermanagement/wwadmins/*" element={protect(<WWAdminManagement />, RouteAuthorisation.viewHaAdmins)} />
            <Route path="usermanagement/clientadmins/*" element={protect(<ClientAdminManagement />, RouteAuthorisation.viewClientAdmins)} />
            <Route path="usermanagement/wisdomusers/*" element={protect(<WisdomUserManagement />, RouteAuthorisation.viewWisdomUsers)} />
            <Route path="clientmanagement/*" element={protect(<ClientManagement />, RouteAuthorisation.viewClients)} />
            <Route path="targetgroups/*" element={protect(<TargetGroups />, RouteAuthorisation.targetGroups)} />
            <Route path="importclients" element={protect(<ImportClients />, RouteAuthorisation.importClients)} />
            <Route path="hub-sites" element={protect(<HubSites />, RouteAuthorisation.hubSites)} />
            <Route path="additional-info" element={<AdditionalInfo />} />
            <Route path="dualbranding/" element={protect(<DualBranding />, RouteAuthorisation.dualBranding)} />
            <Route path="communications" element={protect(<Communications />, RouteAuthorisation.sendCommunications)} />
            <Route path="pending-notifications" element={protect(<PendingNotifications />, RouteAuthorisation.pushNotifications)} />
          </Route>
          <Route path="auth" element={<Auth />} />
          <Route path="login" element={<Auth />} />
        </Routes>
      </AdminUserContextProvider>
    </ModalProvider>
  );
};
